import { render, staticRenderFns } from "./SplitDetail.vue?vue&type=template&id=234e525a"
import script from "./SplitDetail.vue?vue&type=script&lang=js"
export * from "./SplitDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports